<template>
    <div>
        <div class="title">{{ planPackage.name }}</div>
        <div class="subtitle-1 font-weight-medium">
            {{ $n(planPackage.price, 'currency') }}
        </div>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
    props: {
        planPackage: {
            type: Object,
            required: true,
        },
    },

    directives: {
        mask: mask,
    },

    methods: {
        overPriceChanged() {
            this.$emit('over-price-changed', this.planPackage)
        },
    },
}
</script>
